export const DaveEvents = {};

DaveEvents.hasActiveEvent = () => {
  return DaveEvents.isFirstEvent();
}

DaveEvents.displayHint = () => {
  return DaveEvents.isFirstEvent();
}

DaveEvents.genericTalk = () => {
  if(EventStateService.daveDailyEventChecked) return true;
  return !DaveEvents.hasActiveEvent();
}

DaveEvents.isFirstEvent = () => {
  if(EventStateService.daveDailyEventChecked) {
    return false;
  }

  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

  return !EventStateService.daveFirstEvent
}
